import styled from 'styled-components';

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #F0F0F0;
  margin: 8px 0;
`;
